var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from 'ui/styled';
export var StyledDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 16px 0;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 16px 0;\n"])));
export var StyledLink = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 5px;\n  padding: 0;\n"], ["\n  margin: 0 5px;\n  padding: 0;\n"])));
var templateObject_1, templateObject_2;
